import Slider from "@ant-design/react-slick";

export default function Carousel() {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
      <style>{`
        @media (max-width: 639px) {
          .carousel-img-1 { object-position: 35% center; }
          .carousel-img-2 { object-position: 50% center; }
          .carousel-img-3 { object-position: 60% center; }
          .carousel-img-4 { object-position: 35% center; }
        }
      `}</style>
      <div className="h-screen relative overflow-hidden">
        <Slider {...settings} className="h-full">
          {[1, 2, 3, 4].map((n) => (
            <div key={n}>
              <img
                className={`w-full h-screen object-cover carousel-img-${n}`}
                src={`${process.env.PUBLIC_URL}/images/carousel_${n}.JPG`}
                alt=""
              />
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
}